/**
 * useIsAdminOrAig (M286 idea 18): Admin Info and Calculated Fields, under /devtools since they left the Settings hub,
 * are for an admin role (ADMIN_ROLES) or AIG staff (the super-admin email whitelist, useIsSuperAdmin), so a client
 * Admin keeps them. App.tsx's AdminOrAigRoute and the sidebar's two items read this one rule.
 */
import { ADMIN_ROLES } from '@aiga/app-config/permissions';
import { useAuth } from '../contexts/AuthContext';
import { useIsSuperAdmin } from './useIsSuperAdmin';

export function useIsAdminOrAig(): boolean {
  const { role } = useAuth();
  const isAig = useIsSuperAdmin();
  return isAig || (!!role?.name && ADMIN_ROLES.has(role.name));
}
